import React from 'react';
import { BookOpen } from 'lucide-react';
import { useFadeIn } from '../hooks/useFadeIn';
import CodeExamplesContent from './CodeExamplesContent';
import './LandingDocsPage.css';

const LandingDocsPage: React.FC = () => {
  const apiKey = 'YOUR_API_KEY';
  const headerFadeIn = useFadeIn({ delay: 0.1 });
  const contentFadeIn = useFadeIn({ delay: 0.2 });

  return (
    <div className="landing-docs-page">
      <div className="landing-docs-container">
        <div 
          ref={headerFadeIn.ref} 
          className={`landing-docs-header ${headerFadeIn.isVisible ? 'fade-in-hero' : ''}`}
          style={{ 
            animationDelay: `${headerFadeIn.delay}s`,
            opacity: headerFadeIn.isVisible ? undefined : 0
          } as React.CSSProperties}
        >
          <div className="landing-docs-header-content">
            <div className="landing-docs-icon-wrapper">
              <BookOpen className="landing-docs-icon" />
            </div>
            <div>
              <h1 className="landing-docs-title">Documentation</h1>
              <p className="landing-docs-subtitle">Complete guide to integrating with the Novembr platform</p>
            </div>
          </div>
        </div>

        <div 
          ref={contentFadeIn.ref} 
          className={contentFadeIn.isVisible ? 'fade-in-hero' : ''}
          style={{ 
            animationDelay: `${contentFadeIn.delay}s`,
            opacity: contentFadeIn.isVisible ? undefined : 0
          } as React.CSSProperties}
        >
          <CodeExamplesContent apiKey={apiKey} showDocumentation={true} />
        </div>
      </div>
    </div>
  );
};

export default LandingDocsPage;
